import React, { useEffect, useState } from "react";

import AdminToolsDataService from "../../../services/admin-tools.service";
import { NotificationManager } from "react-notifications";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Button, Modal, Select, Table, Tooltip } from "antd";

const { Option } = Select;

const OutBoundSync = () => {
  const { t } = useTranslation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [syncList, setSyncList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [synLoading, setSynLoading] = useState(false);
  const [forceSynLoading, setForceSynLoading] = useState(false);
  const [dealerID, setDealerId] = useState(0);
  const [dealerList, setDealerList] = useState([]);
  const [updateHistory, setUpdateHistory] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [totalPage, setTotalPage] = useState(0);
  const [rowDetails, setRowDetails] = useState({});

  const location = useLocation();
  useEffect(() => {
    if (location.state) {
      if (location.state.dealerID) {
        setDealerId(location.state.dealerID);
        handleGetUpdateHistoryList(location.state.dealerID, pageNo, pageSize);
      }
    } else {
    }

    handleGetUsersList();
  }, []);
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setRowDetails({});
  };
  const handleGetUpdateHistoryList = (id, no, size = 10) => {
    let inputData = {
      dealerId: id || dealerID,
      pageIndex: no,
      pageSize: size,
    };
    try {
      setLoading(true);
      AdminToolsDataService.GetUpdateHistoryList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setLoading(false);
          if (message === "Success") {
            if (responseData?.length > 0) {
              setTotalPage(responseData[0].totalRecordCount);
              setUpdateHistory(responseData);
            } else {
              setTotalPage(0);
              setUpdateHistory([]);
            }
          } else {
            setUpdateHistory([]);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  // Download File
  const handleGetDownloadSync = (row) => {
    const sign = "-";
    const firstvalue = row.jewelryCSVHistoryID.toString();
    const secondvalue = row.typeId;
    let inputData = {
      dealerID: dealerID.toString(),
      summaryID: `${firstvalue}${sign}${secondvalue}`,
    };
    setLoading(true);
    try {
      AdminToolsDataService.DownloadReportSync(inputData)
        .then((response) => {
          if (response.data.statusCode == "Success") {
            if (response.data.statusCode == 200) {
              window.open(response.data.responseData, "__blank");
              setLoading(false);
            } else if (response.data.statusCode == 1001) {
              NotificationManager.error(t("File Not Found"));
              setLoading(false);
            } else {
              NotificationManager.error(t("File Not Found"));
              setLoading(false);
            }
          } else {
            NotificationManager.error(t("File Not Found"));
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          // setLoading(false);
        });
    } catch (error) {
      console.log(error);
      // setLoading(false);
    }
  };

  const handleGetUsersList = () => {
    let inputData = {
      clientType: "",
    };
    try {
      AdminToolsDataService.GetUsersList(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          if (message === "Success") {
            setDealerList(responseData);
          } else {
            setDealerList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleSyncProducts = () => {
    let inputData = {
      dealerId: dealerID || 0,
    };
    try {
      setSynLoading(true);
      AdminToolsDataService.SyncProducts(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setSynLoading(false);
          if (message === "Success") {
            NotificationManager.warning(t("Product Synced Successfully"));
          } else {
            NotificationManager.error(t("Something Went Wrong."));
          }
        })
        .catch((error) => {
          setSynLoading(false);
          console.log(error);
        });
    } catch (error) {
      setSynLoading(false);
      console.log(error);
    }
  };
  const handleSyncProductsForce = () => {
    let inputData = {
      dealerId: dealerID || 0,
    };
    try {
      setForceSynLoading(true);
      AdminToolsDataService.SyncProductsForce(inputData)
        .then((response) => {
          var message = response.data.message;
          var responseData = response.data.responseData;
          setForceSynLoading(false);
          if (message === "Success") {
            NotificationManager.warning(t("Successfully Forced Synced"));
          } else {
            NotificationManager.error(t("Something Went Wrong."));
          }
        })
        .catch((error) => {
          setForceSynLoading(false);
          console.log(error);
        });
    } catch (error) {
      setForceSynLoading(false);
      console.log(error);
    }
  };

  const handleOnChange = (e) => {
    setDealerId(e);
    handleGetUpdateHistoryList(e, pageNo, pageSize);
  };
  function handlePageNoChange(page, pageSize) {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    setPageNo(page);
    handleGetUpdateHistoryList(dealerID, page, pageSize);
  }
  function handlePageSizeChange(current, size) {
    setPageSize(size);
    handleGetUpdateHistoryList(dealerID, current, size);
  }
  const handleGetDetials = (row) => {
    setRowDetails(row);
    setIsModalVisible(true);
  };
  return (
    <React.Fragment>
      <div className="prodetail__section">
        <div className="form__fields">
          <div className="col-md-12">
            <div className="prod__maindiv data__maping">
              <div className="row">
                <div className="col-md-12">
                  <h4 className="workarea__heading">
                    {" "}
                    {t("Sync Products To Your Website")}{" "}
                  </h4>
                </div>
                <div className="col-md-4">
                  <div className="input__block">
                    <label> {t("Select Dealer")} </label>
                    <Select
                      showSearch
                      className="border__grey"
                      placeholder={t("Select Dealer")}
                      optionFilterProp="children"
                      value={dealerID}
                      onChange={handleOnChange}
                    >
                      <Option value=""> {t("Select Dealer")} </Option>
                      {dealerList.map((item, i) => {
                        return (
                          <Option key={i} value={Number(item.dealerID)}>
                            {item.dealerCompany + " ( " + item.dealerID + " )"}
                          </Option>
                        );
                      })}
                    </Select>
                  </div>
                </div>

                <div className="col-lg-12 col-md-12">
                  <div className="prodesc__div">
                    <Table
                      columns={[
                        {
                          title: (
                            <Tooltip title={t("Dealer ID")}>
                              {t("Dealer ID")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "dealerId",
                        },
                        {
                          title: (
                            <Tooltip title={t("Dealer Company")}>
                              {t("Dealer Company")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "dealerCompany",
                        },
                        {
                          title: (
                            <Tooltip title={t("Type")}>{t("Type")}</Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "typeDesc",
                        },
                        {
                          title: (
                            <Tooltip title={t("Status")}>{t("Status")}</Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "statusDesc",
                        },

                        {
                          title: (
                            <Tooltip title={t("Initiated")}>
                              {t("Initiated")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "createdDate",
                          render: (item, row) => {
                            return (
                              <span>
                                {moment(row.createdDate).format(
                                  "DD/MM/YYYY h:mm:ss A"
                                )}
                              </span>
                            );
                          },
                        },
                        {
                          title: (
                            <Tooltip title={t("Completed")}>
                              {t("Completed")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          dataIndex: "completedDate",
                        },

                        {
                          title: (
                            <Tooltip title={t("Details")}>
                              {t("Details")}
                            </Tooltip>
                          ),
                          ellipsis: true,

                          render: (item, row) => {
                            return (
                              <a
                                onClick={() => handleGetDetials(row)}
                                className="linkText"
                              >
                                {t("Details")}
                              </a>
                            );
                          },
                        },
                        {
                          title: (
                            <Tooltip title={t("Download")}>
                              {t("Download")}
                            </Tooltip>
                          ),
                          ellipsis: true,
                          render: (item, row) => {
                            return (
                              <a
                                className="linkText"
                                onClick={() => handleGetDownloadSync(row)}
                              >
                                {t("DownlaodFile")}
                              </a>
                            );
                          },
                        },
                      ]}
                      dataSource={updateHistory}
                      loading={loading}
                      pagination={{
                        size: "small",
                        current: pageNo,
                        pageSize: pageSize,
                        pageSizeOptions: [10, 15, 20, 50, 100],
                        responsive: true,
                        showSizeChanger: true,
                        total: totalPage,
                        onChange: handlePageNoChange,
                        onShowSizeChange: handlePageSizeChange,
                      }}
                    />

                    <div class="col-md-12 mt-3">
                      <div className="outbond__btn">
                        <Button
                          className="primary-btn"
                          style={{ marginRight: "10px" }}
                          onClick={handleSyncProducts}
                          loading={synLoading}
                        >
                          <i
                            class="fa fa-cloud-upload"
                            style={{ color: "white", marginRight: "5px" }}
                          ></i>
                          {t("Sync Products")}
                        </Button>
                        <Button
                          className="primary-btn"
                          style={{ marginRight: "10px" }}
                          onClick={handleSyncProductsForce}
                          loading={forceSynLoading}
                        >
                          {t("Force Full Sync")}
                        </Button>
                        <Button
                          className="primary-btn"
                          onClick={() =>
                            handleGetUpdateHistoryList(
                              dealerID.pageNo,
                              pageNo,
                              pageSize
                            )
                          }
                        >
                          <i
                            className="fa fa-refresh"
                            style={{ color: "white", marginRight: "5px" }}
                          ></i>
                          {t("Update History")}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={t("Detail")}
        visible={isModalVisible}
        className="forgot__password"
        onCancel={handleCancel}
        onOk={handleCancel}
        okText={t("Ok")}
        cancelText={t("Cancel")}
      >
        <div className="form__fields p-0 border-0 mh-auto">
          <div className="input__block">
            <label>
              {t("Total Products Processed")} = <b>{rowDetails.count}</b>
            </label>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default OutBoundSync;
